webpackJsonp([1],{

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7c4160_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_wrapped_md__ = __webpack_require__(45);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7c4160_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_wrapped_md__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('html',[_c('head'),_c('body',[_c('h1',[_vm._v("Wrapped")]),_vm._v(" "),_c('p',[_vm._v("It's December  "),_c('br'),_vm._v("\nThat time of year we all wait for like good little consumers "),_c('br'),_vm._v("\nWhen our digital services package up our year of usage "),_c('br'),_vm._v("\nThe corporate overlords throw us some fun stats "),_c('br'),_vm._v("\nA little reward for never owning anything anymore "),_c('br'),_vm._v("\nBut I digress")]),_vm._v(" "),_c('p',[_vm._v("If you're like me then your number one digital statistical slideshow "),_c('br'),_vm._v("\nIs Spotify wrapped "),_c('br'),_vm._v("\nTo me it evokes the feeling of slow end of year days "),_c('br'),_vm._v("\nHuddled in my old office comparing stats with the guys "),_c('br'),_vm._v("\nHurling playful jeers if a guilty pleasure was over indulged "),_c('br'),_vm._v("\nIt's posting Instagram stories tagging artists hoping they'll share it "),_c('br'),_vm._v("\nFor that quick hit of validation "),_c('br'),_vm._v("\nOr secretly judging friends' questionable tastes")]),_vm._v(" "),_c('p',[_vm._v("I look at my numbers this year "),_c('br'),_vm._v("\nJust shy of 70,000 minutes "),_c('br'),_vm._v("\nIt seems almost preposterous  "),_c('br'),_vm._v("\nA personal record by a significant margin")]),_vm._v(" "),_c('p',[_vm._v("But that's just a number "),_c('br'),_vm._v("\nWhat the number doesn't show "),_c('br'),_vm._v("\nAre the bus rides "),_c('br'),_vm._v("\nThe train journeys "),_c('br'),_vm._v("\nThe long walks "),_c('br'),_vm._v("\nTrying to escape from my corner of reality "),_c('br'),_vm._v("\nTrying to find somewhere new "),_c('br'),_vm._v("\nSomewhere I can feel like me again")]),_vm._v(" "),_c('p',[_vm._v("It doesn't show the late nights  "),_c('br'),_vm._v("\nIn desperate need of some kind of companionship  "),_c('br'),_vm._v("\nAny voice that isn't the one in my own head")]),_vm._v(" "),_c('p',[_vm._v("I read through the artists and the songs  "),_c('br'),_vm._v("\nAll of my top plays "),_c('br'),_vm._v("\nA coterie of the assaulted, the abused, the opressed "),_c('br'),_vm._v("\nThe ones who survived pouring their pain into their art "),_c('br'),_vm._v("\nNow I pour over their art "),_c('br'),_vm._v("\nHoping that focussing on their pain "),_c('br'),_vm._v("\nMight distract me from my own")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.9e9275eaac42065c3bbc.js